import { SECOND } from "../../house-of-innovation/shared";

export function secToMs(seconds: number) {
    return seconds * SECOND;
}
